import { CroppedRegion } from './domain';

export type DefaultRegionCategoryId = 'top' | 'bottom' | 'outer' | 'dress' | 'shoes' | 'bag' | 'accessory' | 'unknown' | 'other';

// Display-space percent coordinates. These are only rule-based starting points before AI segmentation.
export const lookitDefaultCategoryRegions: Record<DefaultRegionCategoryId, CroppedRegion> = {
    top: { x: 26, y: 20, width: 48, height: 26 },
    bottom: { x: 29, y: 49, width: 42, height: 31 },
    outer: { x: 20, y: 14, width: 60, height: 56 },
    dress: { x: 27, y: 20, width: 46, height: 58 },
    shoes: { x: 30, y: 83, width: 40, height: 12 },
    bag: { x: 60, y: 32, width: 26, height: 28 },
    accessory: { x: 58, y: 22, width: 24, height: 24 },
    unknown: { x: 26, y: 26, width: 48, height: 44 },
    other: { x: 26, y: 26, width: 48, height: 44 }
};

export const lookitFullImageRegion: CroppedRegion = { x: 0, y: 0, width: 100, height: 100 };

export function categoryBaseId(categoryId?: string | null): string {
    return (categoryId || '').split(':')[0].trim();
}

export function defaultRegionForCategory(categoryId?: string | null): CroppedRegion | null {
    const baseId = categoryBaseId(categoryId) as DefaultRegionCategoryId;
    const region = lookitDefaultCategoryRegions[baseId];
    return region ? { ...region } : null;
}

export function regionToUnitRatio(region: CroppedRegion): CroppedRegion {
    return {
        x: region.x / 100,
        y: region.y / 100,
        width: region.width / 100,
        height: region.height / 100
    };
}
